{
    "aep_aspiration": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 0
    },
    "aep_aspiration_rouge": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 0
    },
    "aep_borne_fontaine": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 0
    },
    "aep_borne_fontaine_gris": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 0
    },
    "aep_borne_puisage": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 0
    },
    "aep_borne_puisage_gris": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 24
    },
    "aep_bouche_arrosage": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 24
    },
    "aep_bouche_arrosage_gris": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 24
    },
    "aep_bouche_incendie": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 24
    },
    "aep_bouche_incendie_rouge": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 24
    },
    "aep_citerne_incendie": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 48
    },
    "aep_citerne_incendie_rouge": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 48
    },
    "aep_clapet": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 48
    },
    "aep_clapet_outline": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 48
    },
    "aep_compteur_branchement": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 48
    },
    "aep_compteur_debit": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 72
    },
    "aep_compteur_debit_vert": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 72
    },
    "aep_compteur_debit_rouge": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 72
    },
    "aep_compteur_debit_gris": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 72
    },
    "aep_compteur_debit_kaki": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 72
    },
    "aep_compteur_debit_rose": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 96
    },
    "aep_compteur_debit_orange": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 96
    },
    "aep_compteur_debit_bleu": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 96
    },
    "aep_compteur_debit_bleu_clair": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 96
    },
    "aep_compteur_detecteur": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 96
    },
    "aep_point_chloration": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 120
    },
    "aep_point_chloration_vert": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 120
    },
    "aep_point_chloration_bleu": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 120
    },
    "aep_point_prelevement": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 120
    },
    "aep_poteau_incendie": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 120
    },
    "aep_poteau_incendie_rouge": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 144
    },
    "aep_protection_cathodique": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 144
    },
    "aep_purge": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 144
    },
    "trapezoid_blanc": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 144
    },
    "trapezoid_gris": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 144
    },
    "trapezoid": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 168
    },
    "trapezoid_bleu": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 168
    },
    "aep_reservoir_blanc_noir": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 168
    },
    "aep_reservoir_bleu_noir": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 168
    },
    "aep_reservoir_noir_bleu": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 168
    },
    "aep_reservoir_tour": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 192
    },
    "aep_reservoir_tour_bleu": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 192
    },
    "aep_station_alerte": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 192
    },
    "aep_station_desinfection": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 192
    },
    "aep_station_pompage_stock": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 192
    },
    "aep_station_pompage_stock_bleu_blanc": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 216
    },
    "aep_station_pompage_stock_vert": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 216
    },
    "aep_station_pompage_stock_orange": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 48,
        "y": 216
    },
    "aep_station_pompage_stock_rose": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 216
    },
    "aep_station_pompage_stock_bleu_noir": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 216
    },
    "aep_usine_traitement": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 240
    },
    "aep_usine_traitement_bleu": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 240
    },
    "aep_vannes_reseau": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 240
    },
    "aep_ventouse": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 72,
        "y": 240
    },
    "eau_armoire_elec": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 96,
        "y": 240
    },
    "eau_pluviometre": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 0,
        "y": 264
    },
    "eau_point_mesure_nappe": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": false,
        "width": 24,
        "x": 24,
        "y": 264
    },
    "outline_half_circle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 264
    },
    "half_circle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 264
    },
    "outline_quarter_circle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 96,
        "y": 264
    },
    "quarter_circle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 288
    },
    "outline_trapezoid": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 288
    }
}
